import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxWindowModule } from 'jqwidgets-ng/jqxwindow';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxDateTimeInputModule } from 'jqwidgets-ng/jqxdatetimeinput';
import { jqxDropDownButtonModule } from 'jqwidgets-ng/jqxdropdownbutton';

import { CiudadanosComponent } from './ciudadanos.component';
import { CiudadanosEditComponent } from './ciudadanos-edit/ciudadanos-edit.component';
import { CiudadanosTarjetasComponent } from './ciudadanos-tarjetas/ciudadanos-tarjetas.component';
import { CiudadanosListadoTarjetasComponent } from './ciudadanos-listado-tarjetas/ciudadanos-listado-tarjetas.component';

@NgModule({
  declarations: [
    CiudadanosComponent,
    CiudadanosEditComponent,
    CiudadanosTarjetasComponent,
    CiudadanosListadoTarjetasComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    jqxGridModule,
    jqxInputModule,
    jqxWindowModule,
    jqxButtonModule,
    jqxLoaderModule,
    ReactiveFormsModule,
    jqxDateTimeInputModule,
    jqxDropDownButtonModule,
  ],
  exports: [
    CiudadanosComponent
  ]
})
export class CiudadanosModule { }
